import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { capitalize } from "lodash";

import Modal from "components/Modal";

import { CloseConnectCrmModal } from "scenes/Hubly/components/HubModals/components/ConnectCRMModal/actions";

import { useConnectionType } from "./hooks";
import { ConnectCRMModalBody } from "./components";

function ConnectCRMModal() {
  const dispatch = useDispatch();
  const { isCrmReset, isRequiredCrmConnection } = useConnectionType();

  const capitalizedCRM = capitalize(
    useSelector(({ hubly }) => {
      return hubly.connectCrmModal.crm;
    })
  );

  const handleOnClose = (ignoreRequired = false) => {
    if (ignoreRequired || !isRequiredCrmConnection) {
      return dispatch(CloseConnectCrmModal());
    }

    return () => {};
  };

  return (
    <Modal
      isModalOpen
      onClose={() => {
        return handleOnClose();
      }}
    >
      <Modal.Header
        onClose={() => {
          return handleOnClose();
        }}
        disabled={isRequiredCrmConnection}
      >
        <span data-test="connect-crm-modal-header-text">
          {isCrmReset
            ? `Reset your ${capitalizedCRM} credentials`
            : `Connect with ${capitalizedCRM}`}
        </span>
      </Modal.Header>
      <Modal.Body scrolling>
        <ConnectCRMModalBody
          crm={capitalizedCRM}
          onDone={() => {
            return handleOnClose(true);
          }}
        />
      </Modal.Body>
    </Modal>
  );
}

ConnectCRMModal.propTypes = {};
ConnectCRMModal.defaultProps = {};

export default ConnectCRMModal;
